<template>
  <div id="formWrap">
    <h2 class="instH2" v-if="formStatus.systemScreen !== 'instVideoCall'">Деньги на карту до 100 000 рублей</h2>
    <div v-if="formStatus.form" class='instFormWrapAlign'>
<!--      Полоса прогресса и строка «Вероятность одобрения займа N%» скрыты -->
<!--      <progressBar :step-current="stepCounterCurrent" :step-max="stepCounterMax"></progressBar>-->
      <esia></esia>
      <instPreWin v-if="isDocumentsStep && !mainPhotosDone"></instPreWin>
      <div id="stepWrap">
        <h3 v-if="!(isDocumentsStep && mainPhotosDone)">{{ currentStepForm.title }}</h3>

        <div v-for="(item,index) in formFields" :key="index + '' + item.name">
          <component :is="item.component" :fieldName="item.name">
            <template v-if="item.component === 'instCheckBox' && item.chekboxTxtComponent !== undefined" v-slot:content>
              <component :is="item.chekboxTxtComponent"></component>
            </template>
          </component>
        </div>

      </div>

      <div v-if="currentStepForm.sysName === 'Client'" id="instWeekPayment">
        <p>Еженедельный платеж составит:</p>
        <p>{{ paymentInfo.FixedPay | moneyFormat }} ₽</p>
      </div>

      <agreementClientCheckBox v-if="currentStepForm.sysName === 'Client'"></agreementClientCheckBox>

      <button id="confirmStep" class="instButton" v-on:click="confirmStep">{{ currentStepForm.buttonTitle }}</button>


      <div id="someText" v-if="currentStepForm.sysName === 'smsConfirm'">
        <p>Вводом кода, я подтверждаю, что ознакомлен и полностью согласен с <a target="_blank" href="https://finmoll.ru/backend/content/documents/rules_microloans">Правилами предоставления микрозаймов ООО МКК «ФИНМОЛЛ»</a>, <a target="_blank" href="https://finmoll.ru/backend/content/documents/microloan_terms_conditions">Общими условиями микрозаймов ООО МКК ФИНМОЛЛ</a>, Я даю свое информированное <a target="_blank" href="https://lnd.msk.finmoll.com/admd/upload/consentToAdvertising.pdf">Согласие на получение рекламы</a> и даю <a target="_blank" href="https://lnd.msk.finmoll.com/assets/pdf/consent_to_PD_processing.pdf">Согласие на обработку персональных данных</a>, а также вводом кода я подтверждаю присоединении к <a target="_blank" href="https://finmoll.ru/documents/soglashenie-ob-ispolzovanii-asp.pdf">Соглашению об использовании Аналога собственно ручной подписи»</a>.  Я согласен на получение Обществом с ограниченной ответственностью Микрокредитная компания «ФИНМОЛЛ» (ИНН 7705954143, ОГРН 1117746509638) моего Кредитного отчета, сформированного на основании моей кредитной истории в Бюро с целью возможного предоставления мне займа для чего подписываю соответствующее Согласие на <a target="_blank" :href="kiurl">запрос кредитного отчета</a>.</p>
      </div>

      <div  v-if="currentStepForm.sysName === 'Client'" id="agreementClientTxt">
        <p>Нажимая кнопку «Продолжить», я подтверждаю, что в отношениях с ООО МКК «ФИНМОЛЛ» я действую сознательно, свободно, своей волей и в своих интересах, иные лица, к выгоде которых я действую (выгодоприобретатели), отсутствуют, лица, прямо или косвенно контролирующие мои действия, в том числе имеющие возможность определять решения, принимаемые мной, отсутствуют, а также подтверждаю свое согласие на получение рекламных материалов в соответствии с Согласием на получение рекламы и предоставляю право на обработку моих персональных данных на условиях Согласия на обработку ПД</p>
      </div>

      <div id="padlockMsg">
        <svg width="12" height="15" viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M9.75 5.25v-1.5a3.75 3.75 0 00-7.5 0v1.5A2.25 2.25 0 000 7.5v5.25A2.25 2.25 0 002.25 15h7.5A2.25 2.25 0 0012 12.75V7.5a2.25 2.25 0 00-2.25-2.25zm-6-1.5a2.25 2.25 0 114.5 0v1.5h-4.5v-1.5zm6.75 9a.75.75 0 01-.75.75h-7.5a.75.75 0 01-.75-.75V7.5a.75.75 0 01.75-.75h7.5a.75.75 0 01.75.75v5.25z" fill="#8A919C"/></svg>
        <span>Гарантируем безопасность и сохранность ваших данных</span>
      </div>
      <loader v-show="preventSubmitDbClick"></loader>
    </div>
    <div v-else>
      <component :is="formStatus.systemScreen"></component>
    </div>
  </div>
</template>

<script>
import "@/assets/css/variable.css";
import "@/assets/css/fontRoboto.css";
import "@/assets/css/instInputs.css"
import {mapGetters, mapState} from "vuex";


export default {
  name: "instForm",
  data() {
    return {
      preventSubmitDbClick: false,
      kiurl:'/admd/ki/' + window.session_id + '/' + window.tmpTestValue,
    }
  },
  components: {
    loader: () => import('@/views/pdlloan/uiLoader'),
    // progressBar: () => import('@/components/other/progressBar.vue'),
    esia: () => import('@/components/esia.vue'),
    instInput: () => import('@/components/inst/instInput.vue'),
    instDadata: () => import('@/components/inst/instInputDadata.vue'),
    instSelect: () => import('@/components/inst/instSelect.vue'),
    instCheckBox: () => import('@/components/inst/instCheckBox.vue'),
    instRejectTime: () => import('@/components/inst/instRejectTime.vue'),
    instRejectGeo: () => import('@/components/inst/instRejectGeo.vue'),
    instSmsInput: () => import('@/components/inst/instSmsInput.vue'),
    instSaveDemand: ()=>import('@/components/inst/instSaveDemand.vue'),
    instFotoAdd: ()=>import('@/components/inst/instFotoAdd.vue'),
    instSelectBankInfo: ()=>import('@/components/inst/instSelectBankInfo.vue'),
    instPreWin: ()=>import('@/components/inst/instPreWin.vue'),
    instBoxConfirm:()=>import('@/components/inst/instBoxConfirm.vue'),
    agreementClientCheckBox:()=>import('@/components/inst/instAGREEMENT_ALL.vue'),
    instLoaderGetDemandState:()=>import('@/components/inst/instLoaderGetDemandState.vue'),
    instApproveDemandDefault:()=>import('@/components/inst/instApproveDemandDefault.vue'),
    instApproveDemandEasy:()=>import('@/components/inst/instApproveDemandEasy.vue'),
    instVideoCall:()=>import('@/components/inst/instVideoCall.vue'),
    // instCheckBox_AGREEMENT_IU:()=>import('@/components/inst/instCheckBox_AGREEMENT_IU.vue'),
    // instCheckBox_AGREEMENT_PDN:()=>import('@/components/inst/instCheckBox_AGREEMENT_PDN.vue'),
    // instCheckBox_AGREEMENT_ANKETA:()=>import('@/components/inst/instCheckBox_AGREEMENT_ANKETA.vue'),
    instBindigPayment:()=>import('@/components/inst/instBindigPayment.vue'),
    instSmartId:()=>import('@/components/inst/instSmartId.vue'),
    instProductInfo:()=>import('@/components/inst/instProductInfo.vue'),
    instEmptyFormElement:()=>import('@/components/inst/instEmptyFormElement'),
    instAgreement_easyconfirm:()=>import('@/components/inst/instAgreement_easyconfirm')
  },
  computed: {
    ...mapState({
      currentStepForm: state => state.instForm.inst_CurrentStepForm,
      formStatus: state => state.instForm.inst_formStatus,
      demandState: state => state.instForm.demandState,
      valuesVuex: state => state.Form.sendData

    }),
    ...mapGetters(['stepCounterMax', 'stepCounterCurrent', 'isAdressValid', 'paymentInfo']),
    formFields() {
      return this.currentStepForm.fields;
    },
    isDocumentsStep() {
      return this.currentStepForm.sysName === 'documents';
    },
    // Основные фото (паспорт 1-2 и селфи) уже у заявки: passport3 и BankAccount —
    // заглушки, они догружаются позже и признаком незаполненности не считаются.
    // В этом случае незачем показывать ни плашку instPreWin (иначе клиент видит
    // красный «Внесите изменения в документы»), ни заголовок «Прикрепите фото...».
    mainPhotosDone() {
      const photos = this.demandState.allPhotosStatusList || {};
      return ['passport1', 'passport2', 'selfImage'].every(key => parseInt(photos[key], 10) > 0);
    },
    showAgreement(){
      return this.currentStepForm.sysName === 'Client';
    }
  },
  methods: {

    async confirmStep() {
      console.log('confirmStep')
      if (!this.preventSubmitDbClick) {
        if (!this.valuesVuex.AGREEMENT_ALL) {
          this.$store.dispatch('errorShow', {
            target: 'AGREEMENT_ALL',
            value: true,
          });
          console.log('confirmStep AGREEMENT_ALL return false')
          return false;
        }

        document.getElementById('formWrap').scrollIntoView({behavior: 'smooth'});
        window.scrollBy({ top: -200, left: 0 });

        this.preventSubmitDbClick = true;
        const checkStep = await this.$store.dispatch('confirmStep');
        // console.log({checkStep})
        if (!checkStep.status) {
          if (checkStep.typeRejet === 'fieldsError') {
            if (checkStep.data !== undefined && Array.isArray(checkStep.data)) {
              for(let i=0;i<checkStep.data.length;i+=1){
                await this.$store.commit('saveWorkData', {
                  target:checkStep.data[i].field,
                  status:{
                    code:1,
                    msg:checkStep.data[i].errMsg,
                    disable:false
                  }
                });
                await this.$store.commit('saveErrorShow', {
                  target:checkStep.data[i].field,
                  value:true
                });
              }
            }
            const errorLabelArr = document.getElementsByClassName('instErrMsg');
            if(errorLabelArr.length > 0) {
              errorLabelArr[0].scrollIntoView({behavior: 'smooth',block: 'start'});
              window.scrollBy({ top: -200, left: 0 });
            } else {
              document.getElementById('formWrap').scrollIntoView({behavior: 'smooth'});
              window.scrollBy({ top: -200, left: 0 });
            }
          }
          if (checkStep.typeRejet === 'rejectDraft') {
            if (window.canRedirect === 1) {
              this.$palantir.trackAction(128, window.linkToMarket);
              document.location.href = window.linkToMarket;
            } else {
              //телепорт на страницу отказа
              this.$store.dispatch('inst_trySetSystemScreen', checkStep.descrMsg);
            }
          }
          if (checkStep.typeRejet == 'alert') {
            alert(checkStep.descrMsg);
          }
        } else {
          if (this.currentStepForm.nextStep.final) {
            await this.$store.dispatch('inst_trySetSystemScreen',this.currentStepForm.nextStep.name)
          } else {
            await this.$store.dispatch('inst_initForm',this.currentStepForm.nextStep.name)
          }
          document.getElementById('formWrap').scrollIntoView({behavior: 'smooth'});
          window.scrollBy({ top: -200, left: 0 });
        }
        this.preventSubmitDbClick = false;
      }
    },
  },
  mounted() {

  },
  beforeCreate() {

  }
}
</script>

<style scoped>
#formWrap {
  font-family: 'Roboto';
  font-size: var(--font-size-16);
  font-weight: 400;
  margin: 0 auto;
  position: relative;
}

#formWrap p {
  color: black;
}

#stepWrap {
  margin: 0 0 var(--font-size-37) 0
}

#stepWrap > h3 {
  font-size: var(--font-size-20);
  font-weight: 500;
  margin:var(--font-size-16) 0
}

#confirmStep {
}

#instWeekPayment {
  text-align: center;
  margin: var(--font-size-37) 0
}

#instWeekPayment p:first-child {
  font-weight: 500;
  font-size: var(--font-size-16)
}

#instWeekPayment p:last-child {
  font-size: var(--font-size-24);
  font-weight: 700
}

#padlockMsg {
  font-size: var(--font-size-13);
  color: var(--color-gray-type3);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: var(--font-size-10) 0
}

#padlockMsg svg {
  width: var(--font-size-12);
  height: var(--font-size-15);
  margin-right: var(--font-size-08)
}

#agreementClientTxt p{margin: var(--font-size-10) 0;font-size: var(--font-size-13);color: var(--color-gray-type3);}


.instFormWrapAlign{background: white;border-radius: var(--font-size-20);padding: var(--font-size-37) var(--font-size-21) var(--font-size-33)}
.instH2{width: var(--font-size-260)}

@media screen and (min-width: 760px) {
  /*#formWrap {*/
  /*  width: 58.65rem;*/
  /*}*/
  #stepWrap > h3 {text-align: center}
  .instFormWrapAlign{padding: var(--font-size-69) var(--font-size-200) var(--font-size-54)}
  .instH2{width: 100%}
}

</style>